import React from "react";

export default function LabelValor({ label, valor }) {
  return (
    <>
      <div className="label">{label}</div>
      <div className="valor">{valor}</div>
    </>
  );
}
